import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-slides-slide',
  templateUrl: 'slide.component.html'
})
export class SlidesSlideComponent {
  @Input() item: any = {};
  @Input() setting: any;

  constructor(
  ) {
  }

}
